
























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import FontAwesomeIcon from "@/components/FontAwesomeIcon.vue";

@Component({ components: { FontAwesomeIcon } })
export default class AlertInfo extends Vue {
	@Prop({ type: String, default: "" }) alertTitle!: string;
	@Prop(String) alertMessage!: string;

	private hasSlot() {
		return !!this.$slots["default"] || !!this.$scopedSlots["default"];
	}
}
